/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Tld_Pricing_Offered_OnInputs */

const id_tld_pricing_offered_on = /** @type {(inputs: Tld_Pricing_Offered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} ditawarkan lagi ke reseller.`)
};

const en_tld_pricing_offered_on = /** @type {(inputs: Tld_Pricing_Offered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} is offered to resellers again.`)
};

/**
* | output |
* | --- |
* | "{tld} is offered to resellers again." |
*
* @param {Tld_Pricing_Offered_OnInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_offered_on = /** @type {((inputs: Tld_Pricing_Offered_OnInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Offered_OnInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_offered_on(inputs)
	return id_tld_pricing_offered_on(inputs)
});